import "./sdCardInfo.component.scss";

interface IComponentBindings {
    sizeMb: number;
    availableMb: number;
}

export class SDCardInfoComponentController implements angular.IComponentController, IComponentBindings {

    // bindings
    sizeMb: number;
    availableMb: number;

    // component
    percentageUsed: number;

    static $inject = [];

    constructor() {}

    $onInit() {
        this.updatePercentage();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.updatePercentage();
    }

    private updatePercentage(): void {
        this.percentageUsed = +((this.availableMb / this.sizeMb) * 100).toFixed(2);
    }
}

export class SDCardInfoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            sizeMb: "<?",
            availableMb: "<?"
        };

        this.controller = SDCardInfoComponentController;
        this.template = require("./sdCardInfo.component.html");
    }
}
